export default __webpack_public_path__ + "static/media/main-rainy.1d2384fc.jpg";